import { styled } from '@mui/material/styles';
import MuiTableCell from '@mui/material/TableCell';
import React from 'react';
import {
  CardProps,
  Card,
  Paper,
  PaperProps,
  useTheme,
  Grid,
  GridProps,
  Divider,
  Box,
} from '@mui/material';

export const TableCell = styled(MuiTableCell)({
  borderBottom: 'none',
});

interface PaperWrapperProps extends PaperProps {
  children: React.ReactNode;
}

interface CardWrapperProps extends CardProps {
  children: React.ReactNode;
}

interface FooterContainerProps extends GridProps {
  children: React.ReactNode;
}

interface FooterWrapperProps {
  children: React.ReactNode;
}

export const PaperWrapper: React.FC<PaperWrapperProps> = ({
  children,
  ...props
}) => {
  return (
    <Paper
      sx={{
        p: 3,
        borderRadius: 2,
        boxShadow: 3,
        maxWidth: '100%',
        mx: 'auto',
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export const CardWrapper: React.FC<CardWrapperProps> = ({
  children,
  sx = {},
  ...props
}) => {
  const theme = useTheme();

  return (
    <Card
      elevation={3}
      sx={{
        p: 3,
        borderRadius: '12px',
        bgcolor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        boxShadow: theme.shadows[3],
        ...sx,
      }}
      {...props}
    >
      {children}
    </Card>
  );
};

export const FooterContainer: React.FC<FooterContainerProps> = ({
  children,
  ...props
}) => {
  return (
    <Grid
      container
      spacing={2}
      justifyContent="flex-end"
      alignItems="center"
      {...props}
    >
      {children}
    </Grid>
  );
};

export const FooterWrapper: React.FC<FooterWrapperProps> = ({ children }) => {
  return (
    <>
      <Divider sx={{ my: 2 }} />
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        {children}
      </Box>
    </>
  );
};
